import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import ClosingNoteCategoriesAPI from '../../api/closingNoteCategories';

export const SET_CLOSING_NOTE_CATEGORIES = 'SET_CLOSING_NOTE_CATEGORIES';
export const ADD_CLOSING_NOTE_CATEGORY = 'ADD_CLOSING_NOTE_CATEGORY';
export const EDIT_CLOSING_NOTE_CATEGORY = 'EDIT_CLOSING_NOTE_CATEGORY';
export const DELETE_CLOSING_NOTE_CATEGORY = 'DELETE_CLOSING_NOTE_CATEGORY';
export const SET_CLOSING_NOTE_CATEGORY_UI_FLAG =
  'SET_CLOSING_NOTE_CATEGORY_UI_FLAG';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getClosingNoteCategories(_state) {
    return _state.records;
  },
  getClosingNoteCategoryById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isFetching: true });
    try {
      const response = await ClosingNoteCategoriesAPI.get();
      commit(SET_CLOSING_NOTE_CATEGORIES, response.data.payload);
    } finally {
      commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, payload) => {
    commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isCreating: true });
    try {
      const response = await ClosingNoteCategoriesAPI.create(payload);
      commit(ADD_CLOSING_NOTE_CATEGORY, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error?.response?.data?.message || error);
    } finally {
      commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...payload }) => {
    commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isUpdating: true });
    try {
      const response = await ClosingNoteCategoriesAPI.update(id, payload);
      commit(EDIT_CLOSING_NOTE_CATEGORY, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error?.response?.data?.message || error);
    } finally {
      commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isDeleting: true });
    try {
      await ClosingNoteCategoriesAPI.delete(id);
      commit(DELETE_CLOSING_NOTE_CATEGORY, id);
    } catch (error) {
      throw new Error(error?.response?.data?.message || error);
    } finally {
      commit(SET_CLOSING_NOTE_CATEGORY_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [SET_CLOSING_NOTE_CATEGORY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [SET_CLOSING_NOTE_CATEGORIES]: MutationHelpers.set,
  [ADD_CLOSING_NOTE_CATEGORY]: MutationHelpers.create,
  [EDIT_CLOSING_NOTE_CATEGORY]: MutationHelpers.update,
  [DELETE_CLOSING_NOTE_CATEGORY]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
